import { useCallback } from "react"

import { getUserInfo } from "@/services"
import { auth } from "@/utils/auth"

export const useFetchRole = (dispatch: React.Dispatch<any>) => {
    const handleFetchRole = useCallback(
        async (token: string) => {
            auth.setToken(token)

            const { code, data } = await getUserInfo()

            if (code === 0) {
                dispatch({
                    type: "updateContext",
                    payload: {
                        user: {
                            ...data,
                        },
                    },
                })

                return {
                    channelMasterId: data.channelId,
                    uid: data.uid,
                    nickName: data.nickName,
                }
            }

            dispatch({
                type: "updateContext",
                payload: {
                    user: null,
                },
            })
            return null
        },
        [dispatch]
    )
    return handleFetchRole
}
